<template>
    <div class="row">
        <div class="col-sm-12">
            <h6 class="font-weight-normal">
                {{ $t(`${pageID}.config.admin.custom_admin_email.recipients.title`) }}
            </h6>
            <hr class="mt-2" />
            <p>{{ $t(`${pageID}.config.admin.custom_admin_email.recipients.description`) }}</p>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <MaterialInput
                            :readonly="readonlyFormItem"
                            :disabled="readonlyFormItem"
                            class="city-form-group city-bg"
                            id="input-custom_admin_email_recipients"
                            name="custom_admin_email_recipients"
                            v-model.trim="form.custom_admin_email_recipients"
                            v-validate="'emails'"
                            :inputClasses="[{'is-invalid': fnHasError('custom_admin_email_recipients')}]"
                            :error="fnFirstError('custom_admin_email_recipients')"
                            :helpText="`${pageID}.config.admin.custom_admin_email.recipients.help`">
                            {{ $t(`${pageID}.config.admin.custom_admin_email.recipients.label`) }}
                        </MaterialInput>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <h6 class="font-weight-normal">
                            {{ $t(`${pageID}.config.admin.custom_admin_email.send_options.title`) }}
                        </h6>
                        <div class="d-flex flex-wrap d-sm-inline-flex flex-sm-nowrap">
                            <div class="form-check city-form-check"
                                :class="[{'is-invalid': fnHasError(`custom_admin_email_send_options`) }]"
                                v-for="option in lists.sendOptionsEmail"
                                :key="`email-option-${option.id}`">
                                <input class="form-check-input"
                                    type="checkbox"
                                    :disabled="readonlyFormItem || !hasRecipients"
                                    v-model="form.custom_admin_email_send_options"
                                    :value="option.value"
                                    :id="`cb-email-option-${option.id}`"
                                    :name="`custom_admin_email_send_options`"
                                    v-validate="{required: false}">
                                <label class="form-check-label" :for="`cb-email-option-${option.id}`">
                                    {{ option.name }}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import GlobalMixin from '@/app/shared/mixins/global';
    import { isArray } from "@config/utils";

    export default {
        mixins: [
            GlobalMixin
        ],
        inject: {
            parentValidator: 'parentValidator',
        },
        props: {
            value: {
                type: Object,
                default: () => {
                    return {
                        custom_admin_email_recipients: null,
                        custom_admin_email_send_options: [],
                    };
                },
            },
            componentId: {
                type: String,
                require: true,
            },
            readonlyFormItem: {
                type: Boolean,
                require: true,
            },
        },
        data() {
            return {
                pageID: null,
                form: this.value,
                lists: {
                    sendOptionsEmail: [
                        {
                            id: 'cc',
                            name: this.$t(`${this.componentId}.config.admin.custom_admin_email.send_options.cc.title`),
                            value: 'cc',
                        },
                        {
                            id: 'bcc',
                            name: this.$t(`${this.componentId}.config.admin.custom_admin_email.send_options.bcc.title`),
                            value: 'bcc',
                        },
                    ],
                },
            }
        },
        created() {
            this.$validator = this.parentValidator;
        },
        beforeMount() {
            this.pageID = this.componentId;
        },
        computed: {
            hasRecipients() {
                return (this.form.custom_admin_email_recipients || []).length;
            }
        },
        methods: {
            resetSendOptions() {
                this.$set(this.form, 'custom_admin_email_send_options', []);
            }
        },
        watch: {
            'form.custom_admin_email_recipients': {
                deep: true,
                handler(newValue, oldValue){
                    if(!newValue) {
                        this.resetSendOptions();
                    }
                }
            },
            'form.custom_admin_email_send_options': {
                deep: true,
                handler(newValue, oldValue){
                    if(newValue != oldValue && !isArray(newValue)) {
                        this.resetSendOptions();
                    }
                }
            }
        },
    }
</script>
